import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Computer, Cloud, Users, Cpu, Network, Globe, Grid, MoreHorizontal } from 'lucide-react';
import './services.css';

const ServicesPage = () => {
  const navigate = useNavigate();

  const services = [
    {
      Icon: Computer,
      title: 'SOFTWARE',
      description: 'Linux | Windows | Scientific Software\nIntel Compilers | MATLAB',
      path: '/services/software',
      isHighlight: false
    },
    {
      Icon: Cloud,
      title: 'CLOUD COMPUTING',
      description: 'Management and orchestration\nsoftware for the IITD private cloud.',
      path: '/services/cloud',
      isHighlight: false
    },
    {
      Icon: Users,
      title: 'USER ADMIN & INFRA',
      description: 'Revalidation | Suspension | Bulk\nCreation of Users | Forgot Password',
      path: '/services/user-admin',
      isHighlight: false
    },
    {
      Icon: Cpu,
      title: 'HPC',
      description: 'The Central Hybrid Supercomputing\nCluster at IITD',
      path: '/services/hpc',
      isHighlight: false
    },
    {
      Icon: Network,
      title: 'NETWORK',
      description: 'LAN | Wi-Fi | VPN | IITD Proxy | Network Issues | Certificates',
      path: '/services/network',
      isHighlight: false
    },
    {
      Icon: Globe,
      title: 'WEB SERVICES',
      description: 'Web Development | Web Hosting | E-mail Configuration',
      path: '/services/web',
      isHighlight: false
    },
    {
      Icon: Grid,
      title: 'ERP',
      description: 'HRMS | Payroll | Leave | Academics | Faculty Recruitment | E-Services',
      path: '/services/erp',
      isHighlight: false
    },
    {
      Icon: MoreHorizontal,
      title: 'MISCELLANEOUS',
      description: 'Download Server | Recruitment | Policies | Track Data Usage',
      path: '/services/misc',
      isHighlight: false
    }
  ];

  const handleServiceClick = (path) => {
    navigate(path);
  };

  return (
    <div className="services-section">
      <div className="container">
        <h2 className="page-title">
          SERVING IT @ <span className="highlight-title">IITD</span>
        </h2>
        
        <p className="section-description text-center">
          The Computer Services Centre currently installs and manages all of the centrally available network, hardware and software resources in IIT Delhi. CSC also houses computational labs for the conduct of UG/PG Lab courses and examinations.
        </p>

        <h3 className="highlights-heading text-center d-flex justify-content-center">HIGHLIGHTS</h3>

        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div 
                className="service-card cursor-pointer" 
                onClick={() => handleServiceClick(service.path)}
                role="button"
                tabIndex={0}
              >
                <div className="bubble-1"></div>
                <div className="bubble-2"></div>
                <div className="bubble-3"></div>
                
                <div className="card-body text-center">
                  <div className="icon-wrapper">
                    <service.Icon size={24} />
                  </div>
                  <h5 className="card-title">{service.title}</h5>
                  <p className="card-text">
                    {service.description.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        {i === 0 && <br />}
                      </React.Fragment>
                    ))}
                  </p>
                  <span className="btn-link">View More...</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;